<h1 mat-dialog-title>
  Custom table
</h1>
<div mat-dialog-content>
  <form [formGroup]="custom">
    <div>
      <div class="radio-label">
        <label>Color</label>
      </div>
      <mat-radio-group formControlName="teamGuid">
        <mat-radio-button [value]="broadcast.config.awayConfig.id">
          Away
        </mat-radio-button>
        <mat-radio-button [value]="broadcast.config.homeConfig.id">
          Home
        </mat-radio-button>
        <mat-radio-button [value]="null">
          Neutral
        </mat-radio-button>
      </mat-radio-group>
    </div>
    <div>
      <mat-form-field>
        <mat-label>Title</mat-label>
        <input matInput formControlName="title">
      </mat-form-field>
      <mat-form-field>
        <mat-label>Width</mat-label>
        <input matInput type="number" formControlName="width">
      </mat-form-field>
    </div>
    <mat-grid-list cols="2" *ngFor="let row of broadcast.customTable?.data; index as i" rowHeight="65">
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>{{i+1}}.label</mat-label>
          <input matInput [formControlName]="'label' + i">
        </mat-form-field>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-form-field>
          <mat-label>{{i+1}}.value</mat-label>
          <input matInput [formControlName]="'value' + i">
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</div>
<div mat-dialog-actions>
  <button mat-flat-button [mat-dialog-close]="false">
    Close
  </button>
  <!--<button mat-flat-button (click)="updateSize(1, 0)">
    Row +
  </button>
  <button mat-flat-button (click)="updateSize(-1, 0)">
    Row -
  </button>
  <button mat-flat-button (click)="updateSize(0, 1)">
    Col +
  </button>
  <button mat-flat-button (click)="updateSize(0, -1)">
    Col -
  </button>-->
  <button mat-flat-button color="primary" (click)="update()" cdkFocusInitial>
    <mat-icon>done</mat-icon>
    Update
  </button>
</div>
